import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";
import Validator from "validatorjs";
import { connect } from "redux-vue";
import * as userActions from "../actions/user";
import ApiError from "../components/ApiError";
import LoadingIndicator from "../components/LoadingIndicator";
import ValidatedComponent from "../components/ValidatedComponent";

const ContactModal = modalPageDecorator({
  props: ["app", "user", "contact"],

  data() {
    return {
      formData: {
        name: "",
        title: "",
        email: "",
        country: "",
        message: ""
      },
      formRules: {
        name: "required|max:50",
        title: "required|max:50",
        email: "required|email",
        country: "required",
        message: "required"
      },
      formErrors: null,
      formLabels: {
        name: this.$t('contact_modal.name_label'),
        title: this.$t('contact_modal.title_label'),
        email: this.$t('contact_modal.email_label'),
        country: this.$t('contact_modal.country_label'),
        message: this.$t('contact_modal.describe_label')
      },
    }
  },

  methods: {
    /**
     *
     * @param event
     * @returns {Promise<void>}
     */
    async onSubmitPress(event) {
      event.preventDefault();

      const validation = new Validator(this.formData, this.formRules);

      validation.setAttributeFormatter((attribute) =>
        this.formLabels[attribute].toLowerCase()
      );

      if (validation.passes()) {
        this.formErrors = null;
        await this.contact(this.formData);

        if (this.user.contactSuccess) {
          this.$router.replace({name: 'ContactResponseModal'});
        }
      } else {
        this.formErrors = validation.errors.all();
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container md:max-w-3xl mx-auto rounded shadow-lg relative z-50 overflow-hidden">
            <div class="bg-gray-200 py-5 relative">
              <div onClick={this.dismiss} class="cursor-pointer z-50 absolute left-0 top-0 m-4">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
              </div>
              <div class="w-11/12 lg:w-8/12 mx-auto">
                <h3 class="font-bold text-2xl mt-10 lg:mt-0">
                  {this.$t('contact_modal.h1')}
                </h3>
                <small class="text-gray-600">
                  {this.$t('contact_modal.h2')}
                </small>
              </div>
            </div>

            <div class="w-11/12 lg:w-8/12 mx-auto">
              <div class="pt-5 pb-10">
                <form action="#">
                  <div class="mb-4">
                    <em class="text-xs text-gray-600">* {this.$t('contact_modal.required')}</em>
                  </div>

                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="name">
                      {this.formLabels.name}
                    </label>
                    <ValidatedComponent
                      name="name"
                      errors={this.formErrors}
                      classname="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <input class={classname} v-model={this.formData.name} id="name" type="text"/>
                      )}
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="title">
                      {this.formLabels.title}
                    </label>
                    <ValidatedComponent
                      name="title"
                      errors={this.formErrors}
                      classname="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <input class={classname} v-model={this.formData.title} id="title" type="text"/>
                      )}
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="email">
                      {this.formLabels.email}
                    </label>
                    <ValidatedComponent
                      name="email"
                      errors={this.formErrors}
                      classname="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <input class={classname} v-model={this.formData.email} id="email" type="email"/>
                      )}
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="country">
                      {this.formLabels.country}
                    </label>
                    <ValidatedComponent
                      name="country"
                      errors={this.formErrors}
                      classname="block appearance-none w-full bg-gray-200 text-sm border border-faded-200 text-gray-700 p-2 rounded leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <div class="relative">
                          <select
                            class={classname}
                            v-model={this.formData.country}
                            id="country">
                            <option selected disabled value=""></option>
                            {this.app.countries.map(i => (
                              <option value={i.id} key={i.id}>
                                {i.country}
                              </option>
                            ))}
                          </select>
                          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <i class="mdi mdi-chevron-down"></i>
                          </div>
                        </div>
                      )}
                    />
                  </div>

                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="message">
                      {this.formLabels.message}
                    </label>
                    <ValidatedComponent
                      name="message"
                      errors={this.formErrors}
                      classname="bg-gray-200 text-sm appearance-none border border-faded-200 rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      renderComponent={classname => (
                        <textarea class={classname} v-model={this.formData.message} id="message" rows="5"></textarea>
                      )}
                    />
                  </div>

                  <ApiError error={this.user.contactError} />

                  <button
                    class="flex-shrink-0 lg:mr-8 mb-3 lg:mb-0 px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                    type="submit" onClick={this.onSubmitPress} disabled={this.user.contact}>
                    {this.user.contact && <LoadingIndicator/>}
                    {this.user.contact || (
                      <fragment>
                        {this.$t('submit')}
                        <i class="mdi mdi-arrow-right ml-5"></i>
                      </fragment>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    )
  }
});

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.user
  };
}

function mapActionToProps(dispatch) {
  return {
    contact: async data => await dispatch(userActions.contact(data))
  };
}

export default connect(mapStateToProps, mapActionToProps)(ContactModal);